import { useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";

export default function BackupSettings({ onBackup, onRestore, t = {} }) {
  const restoreInputRef = useRef(null);

  return (
    <div className="panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{t.data || "Data"}</p>
          <h3>{t.backupAndRestore || "Backup and restore"}</h3>
        </div>
      </div>
      <input
        ref={restoreInputRef}
        accept="application/json,.json"
        className="hidden-input"
        type="file"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onRestore(file);
          event.target.value = "";
        }}
      />
      <div className="button-row">
        <Button fillMode="outline" icon="download" onClick={onBackup}>
          {t.downloadBackup || "Download backup"}
        </Button>
        <Button fillMode="outline" icon="upload" onClick={() => restoreInputRef.current?.click()}>
          {t.restoreBackup || "Restore backup"}
        </Button>
      </div>
    </div>
  );
}
